import axios from "axios";

class CertificatApi {
  static pdfLink: string;

  static async getCertificat(data: {
    name: string;
    email: string;
    course: string;
    certificat_hours: string;
  }) {
    const form = new URLSearchParams();
    form.append("name", data.name);
    form.append("email", data.email);
    form.append(
      "course",
      data.course + " (" + data.certificat_hours + " часов)"
    );

    try {
      const response = await axios.post(
        "https://edu.emir.gov.ru/generatecert/generate_certificate",
        form,
        {
          headers: {
            accept: "application/json",
          },
        }
      );

      const fileURL = response.data["pdf_url"];
      this.pdfLink = response.data["link"];

      const url = `https://edu.emir.gov.ru/generatecert${fileURL}`;

      return { pdfLink: this.pdfLink, downloadLink: url };
    } catch (error) {
      console.error("Error generating certificate:", error);
    }
  }

  static async sendCertificat() {
    try {
      const form = document.createElement("form");
      form.method = "POST";
      form.action = "https://ipklms.sportedu.ru/login/emir_users.php";

      const input = document.createElement("input");
      input.type = "hidden";
      input.name = "certificat";
      input.value = JSON.stringify(localStorage.getItem("certificat_link"));
      form.appendChild(input);

      document.body.appendChild(form);
      form.submit();

      form.remove();
    } catch (error) {
      console.error("Error", error);
    }
  }
}

export default CertificatApi;
